const styles = {
  root: {
    width: '100%',
    position: 'absolute',
    zIndex: 999,
    top: { xs: 55, lg: 30 },
    left: 0,
    right: 0,
    paddingX: 2,
    display: 'flex',
  },

  filtersSelectedContainer: {
    flexGrow: 1,
    overflow: 'hidden',
    paddingRight: 1.5,
  },

}

export default styles
